/**
 * The amount of rotation in degrees
 */
export const ROTATION_AMOUNT = 90;
/**
 * Visibility of the rotation related buttons
 */

export let ROTATION_MODE;
/**
 * Defined the component's own properties
 */

(function (ROTATION_MODE) {
  ROTATION_MODE[ROTATION_MODE["clockwise"] = 0] = "clockwise";
  ROTATION_MODE[ROTATION_MODE["anticlockwise"] = 1] = "anticlockwise";
  ROTATION_MODE[ROTATION_MODE["all"] = 2] = "all";
})(ROTATION_MODE || (ROTATION_MODE = {}));
//# sourceMappingURL=rotation-model.js.map